import { useEffect, useState } from 'react'
import { UseFormReturn } from 'react-hook-form'

import { AutocompleteOption, TimeLineGridConfig } from '@types'

type UseMainObjectHandlersType = {
  methods: UseFormReturn<TimeLineGridConfig>
}

export const useMainObjectHandlers = (props: UseMainObjectHandlersType) => {
  const {
    methods: { watch, setValue },
  } = props

  const watchMainObjectType = watch('mainObject.objectType')
  const watchMainObjectGroupTitleScript = watch('mainObject.groupTitleScript')
  const watchMainObjectGroupTitleType = watch('mainObject.groupTitleType')
  const watchMainObjectGroupTitleDisplayField = watch('mainObject.groupTitleDisplayField')
  const watchMainObjectGroupField = watch('mainObject.groupField')
  const watchMainObjectGroupFieldKey = watch('mainObject.groupFieldKey')

  const [mainObjectShowGroupTitleScriptDialog, setMainObjectShowGroupTitleScriptDialog] =
    useState(false)

  useEffect(() => {
    const fields = watchMainObjectGroupField?.filter(item => item.field)

    if (!fields?.length) {
      setValue('mainObject.groupTitleDisplayField', [])
      setValue('mainObject.groupTitleDisplayFieldKey', '')
    }
  }, [watchMainObjectGroupField])

  const handleChangeMainObjectShowGroupTitleScriptDialog = (value: boolean) => {
    setMainObjectShowGroupTitleScriptDialog(value)
  }

  const handleChangeMainObjectGroupTitleScript = (value: string) => {
    setValue('mainObject.groupTitleScript', value)
  }

  const handleChangeMainObjectGroupTitleType = (value: AutocompleteOption) => {
    if (!value || value.id !== watchMainObjectGroupTitleType?.id) {
      setValue('mainObject.groupTitleScript', '')
    }
  }

  const handleChangeMainObjectType = (value: string) => {
    if (value !== watchMainObjectType) {
      setValue('mainObject.groupField', undefined)
      setValue('mainObject.groupFieldKey', '')
      setValue('mainObject.groupTitleDisplayField', [])
      setValue('mainObject.groupTitleDisplayFieldKey', '')
    }
  }

  return {
    state: {
      watchMainObjectType,
      mainObjectShowGroupTitleScriptDialog,
      watchMainObjectGroupTitleScript,
      watchMainObjectGroupTitleType,
      watchMainObjectGroupField,
      watchMainObjectGroupTitleDisplayField,
      watchMainObjectGroupFieldKey,
    },
    data: {},
    handlers: {
      handleChangeMainObjectShowGroupTitleScriptDialog,
      handleChangeMainObjectGroupTitleScript,
      handleChangeMainObjectGroupTitleType,
      handleChangeMainObjectType,
    },
  }
}
